import React, { useContext, useReducer } from 'react';
import { Channel } from '@at/consumer-web-types';
import { useAppContext } from '../app/app-context.hoc.js';
import { convertChannel } from '../util/channel.js';
import { useParams } from 'react-router';
import { defaultChannel } from '../types.js';
const defaultValue = {
    channel: defaultChannel,
    userSignedIn: false,
};
const PageStateContext = React.createContext({});
const reducer = (state, action) => {
    switch (action.type) {
        case 'signInUser':
            return Object.assign(Object.assign({}, state), { userSignedIn: true });
        case 'signOutUser':
            return Object.assign(Object.assign({}, state), { userSignedIn: false });
        case 'updateChannel':
            return Object.assign(Object.assign({}, state), { channel: action.channel || defaultChannel });
        case 'reset':
        default:
            return defaultValue;
    }
};
const PageStateProvider = ({ channel, children }) => {
    const value = Object.assign({}, defaultValue);
    const params = useParams();
    const matchChannel = params && convertChannel(params.channel);
    value.channel = channel || matchChannel || Channel.cars;
    const appContext = useAppContext();
    value.userSignedIn = appContext.isUserSignedIn();
    const [state, dispatch] = useReducer(reducer, value);
    return (React.createElement(PageStateContext.Provider, { value: {
            state: state,
            dispatch: dispatch,
            updateChannel: (channel) => {
                dispatch({ type: 'updateChannel', channel });
            },
            signInUser: () => {
                dispatch({ type: 'signInUser' });
            },
            signOutUser: () => {
                dispatch({ type: 'signOutUser' });
            },
        } }, children));
};
const withPageState = (WC, dProps = { channel: defaultChannel }) => {
    const WithPageState = (props) => {
        return (React.createElement(PageStateProvider, { channel: dProps.channel },
            React.createElement(WC, Object.assign({}, props))));
    };
    return WithPageState;
};
const usePageState = () => useContext(PageStateContext);
export { withPageState, PageStateProvider, usePageState };
